export enum TerminalTransportKind {
  AUTO = 'auto',
  MOCK = 'mock',
  LOCAL = 'local',
  RELAY = 'relay',
  NONE = 'none',
}

export enum TerminalConnectionStatus {
  CONNECTING = 'connecting',
  ONLINE = 'online',
  RECONNECTING = 'reconnecting',
  OFFLINE = 'offline',
  NO_DAEMON = 'no_daemon',
}

export enum TerminalSlashCommand {
  CD = 'cd',
  CLEAR = 'clear',
  NEW = 'new',
  HELP = 'help',
  MOVE = 'move',
  ATTACH = 'attach',
  MODEL = 'model',
}

export enum TerminalLogItemType {
  ENTRY = 'entry',
  TOOL_GROUP = 'tool_group',
  SUBAGENT = 'subagent',
}

export enum TerminalInputMode {
  CLAUDE = 'claude',
  SHELL = 'shell',
}

export enum TerminalMenuKind {
  SLASH = 'slash',
  MENTION = 'mention',
}

export enum TerminalKey {
  ENTER = 'Enter',
  ESCAPE = 'Escape',
  TAB = 'Tab',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  BACKSPACE = 'Backspace',
  INTERRUPT = 'c',
}

export enum TerminalDotTone {
  ONLINE = 'online',
  IDLE = 'idle',
  WARNING = 'warning',
}

export enum TerminalSendFailure {
  DEVICE_OFFLINE = 'device_offline',
  TOO_LARGE = 'too_large',
  INVALID = 'invalid',
  NOT_FOUND = 'not_found',
  UNKNOWN = 'unknown',
}

export enum TerminalPendingStatus {
  SENDING = 'sending',
  FAILED = 'failed',
}

export enum TerminalAttachmentError {
  TOO_LARGE = 'too_large',
  TYPE_NOT_ALLOWED = 'type_not_allowed',
  EMPTY = 'empty',
  TOO_MANY = 'too_many',
}
